export const categories = [
  {
    id: "sandwich",
    name: "샌드위치",
    icon: process.env.PUBLIC_URL + "/images/sandwich/sandwich01.png",
  },
  {
    id: "salad",
    name: "샐러드",
    icon: process.env.PUBLIC_URL + "/images/salad/salad01.png",
  },
  {
    id: "side",
    name: "사이드",
    icon: process.env.PUBLIC_URL + "/images/sideMenu/side01.png",
  },
  {
    id: "drink",
    name: "음료",
    icon: process.env.PUBLIC_URL + "/images/drink/drink01.png",
  },
];
